import React from 'react';
import { connect } from 'react-redux';

import { toggleChat } from 'apps/auth/actions/chatAction';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';

const KycInvalidPage = (props) => {
    return (
        <BaseLayout>
            <InfoPage
                animatedIconFail
                headerText={props.title}
                secondaryText={props.text}
                topButtonCaption={props.notNow}
                topButtonType="link"
                topButtonLink={AUTH_SEND_MAIN_LINK}
                primaryButtonType="link"
                primaryButtonCaption={props.contactSupport}
                primaryButtonOnClick={(e) => {
                    e.preventDefault();
                    props.toggleChat(true);
                }}
            />
        </BaseLayout>
    );
};
const mapStateToProps = (state) => {
    return {
        title: state.messages.pageMessages.title,
        text: state.messages.pageMessages.text,
        contactSupport: state.messages.pageMessages.contactSupport,
        notNow: state.messages.pageMessages.notNow,
    };
};
export default connect(mapStateToProps, { toggleChat })(BasePage(KycInvalidPage));
